import { PURCHASE_ORDER_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../documents/AvailableReplacementsModal.js";

interface Props {
  handleClose(): void;
}

export function PurchaseOrderTextsAvailableReplacementsModal({
  handleClose,
}: Props) {
  return (
    <AvailableReplacementsModal
      scope={PURCHASE_ORDER_SCOPE}
      handleClose={handleClose}
    />
  );
}
